import { render, staticRenderFns } from "./categories-cell.vue?vue&type=template&id=3e139ac6&scoped=true&"
import script from "./categories-cell.vue?vue&type=script&lang=js&"
export * from "./categories-cell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e139ac6",
  null
  
)

export default component.exports